var lx = lx || {};

lx.rsvp = {
	goingMore: function (pEty, pId, pPg, pThis, pMore){
		lx.load.add();
		apex.server.process("rsvpArticleDetails", {x01: pEty, x02: pId, x03: pPg, x04: pMore}, {dataType: 'html'})
		.then( function (d) {
			lx.load.remove();
			$(pThis).hide();
			$('#Art' + pId).replaceWith(d);
		} );
	},
	
	rsvpCert: function (pMsg,pInfo) {
		var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--warning t-Alert"><div class="t-Alert-wrap"><div class="t-Alert-icon" style="padding:1.2rem 1.6rem;"><span class="t-Icon"></span></div><div style="width:100%;padding:1.6rem;">' + pInfo + '</div></div></div>';
		var lButtons = [];
			
		dialogDiv = dialogDiv + pMsg;
		lButtons.push({label: "OK", id: "certOk", js: "lxpDialog.close(this);", class:"t-Button--primary", fa:"fas fawe-check-circle"});
		lx.dialog.open({id:"certRsvp",maxWidth:"600px",title:"Certifications",html:dialogDiv, buttons: lButtons});
	}, 
	respond: (pId, pEty, pResponse, pThis, pCuhId, pContact, pConfirmed) => { 
		if (pResponse == 'D' && !pConfirmed) { 
			// window.currentElement is introduced to store the value of 'this' (the clicked element)
			// It is defined in the page 1 JS so that the correct reference is passed to the function
			window.currentElement = pThis;

			const jsFunctionString = `
				window.parent.lx.rsvp.respond(
					${pId}, 
					${pEty}, 
					'${pResponse}', 
					window.currentElement, 
					${pCuhId}, 
					${pContact}, 
					true
				);
				window.parent.$('.lxpDialog').css('display', 'none');
			`;

			lx.info.actionConfirm({
				type: "warning",
				msg: lx.tran.get("RSVP_DECLINE_CONFIRM_MSG"),
				js: jsFunctionString
			});

			window.parent.$('.lxpDialog').css('z-index', 9999);

			return;
		}

		const vCalendar = $(pThis).closest(".feed-actions").parent().hasClass("cal_det-btns");
		const vArtDet = $(pThis).closest(".feed-actions").hasClass("lxArtRsvpFrm");

		$(pThis).closest(".feed-actions").find(".feed-btn").toggle();
		lx.load.add();

		apex.server.process("rsvpSaveResponse", { 
			x01: pId, 
			x02: pEty, 
			x03: pResponse, 
			x04: pCuhId, 
			x05: pContact 
		}, { dataType: 'json' })
			.then((d) => {
				lx.load.remove();
				if (d.survey) {
					window.location = d.url;
				} else if (d.link) {
					window.location = d.link;
				} else if (d.contact || d.connect) {
					lx.conn.syncInfo('RSVP_' + (d.connect ? 'CON' : 'SHARE'), d.cnctId, () => {
						lx.rsvp.respond(pId, pEty, pResponse, window.currentElement, pCuhId, 
							(d.contact ? 'CNTCT' : 'CNCT') + (d.shareEmail ? '_E' : '_N'));
					});
					return;
				} else if (d.err && d.info) {
					lx.rsvp.rsvpCert(d.err, d.info);
				} else if (d.err) {
					lx.info.alert(d.err);
				} else if (vCalendar) {
					const vEty = ['NEWS', 'EVENTS', 'JOBS', 'BID'];
					setTimeout(() => {
						apex.server.process("getCalendarDetails", { 
							x01: vEty[pEty - 1], 
							x02: pId 
						}, { dataType: 'html' })
							.then((html) => {
								if (html !== "")
									$(pThis).closest(".cal_det").replaceWith(html);
							});
					}, 500);
				} else if (vArtDet) {
					if (d.badges) {
						$(pThis).closest(".lxArt").find('.article-badges').replaceWith(d.badges);
					} else if (d.status)
						$(pThis).closest(".lxArt").find('.rsvp_status').replaceWith(d.status);
					if (pResponse === "A")
						$(".art-status2").show();
					else
						$(".art-status2").hide();
					if (d.going)
						$(pThis).closest(".cont").find(".lxArtOthers").replaceWith(d.going);
					if (d.btns)
						$(pThis).closest(".feed-actions").find('.rsvpBtnsContainer').replaceWith(d.btns);
				} else {
					setTimeout(() => {
						lx.feed.notifyRefresh(pThis, pEty, pId);
					}, 500);
				}
			});
	},
    review: {
        clear: false,
        clearTime: function (pThis) {
            if (lx.rsvp.review.clear) {
                var $reviewForm = $(pThis).closest("table");
                if (pThis.id == "rsvpReviewVal") $reviewForm.find("#rsvpReviewEnd").val("");
                else $reviewForm.find("#rsvpReviewVal").val("");
                $("#rsvprReviewUpdate").addClass("red");
            }
        },
        open: function (pId, pThis, pUpdate) {
			var vVal, vStart, vEnd, vOrigin = "NOTIFY";
			if ($(pThis).closest(".lxProfHrsItem").length > 0) {
				vOrigin = "PROFILE";
			} else if (pThis.id == "igRsvpReview") {
				vOrigin = "igRsvp";
			}

			if (pId == -1) {
				$(".rsvpReviewForm").remove();
				return;
			}

			if (pUpdate) {
				vVal = $v("rsvpReviewVal");
				vStart = $v("rsvpReviewStart");
				vEnd = $v("rsvpReviewEnd");
			}
			lx.load.add();
			apex.server.process("rsvpReview", {
				x01: pId,
				x02: vVal,
				x03: vStart,
				x04: vEnd
			},{dataType: 'html'})
			.then(function (d) {
				lx.load.remove();
				if (pUpdate) {
					$(pThis).closest('.rsvpReviewForm').find("div.err").remove();
					var vMsg = $(d).text().split(";");
					if (vMsg[0] == "OK") {
						var vTime = "" + vMsg[3] + ":" + vMsg[4];
						//alert(vTime);
						lx.rsvp.review.clear = false;
						$("#rsvpReviewVal").val(vTime);
						$s("rsvpReviewStart", vMsg[1]);
						$s("rsvpReviewEnd", vMsg[2]);
						lx.rsvp.review.clear = true;

						if (vOrigin == "NOTIFY") {
							//$(pThis).closest('.feed-actions').find(".rsvpReviewBtn").show();
							$(pThis).closest('.feed-post').find(".feedEventAttTime").text(vTime);
						} else if (vOrigin == "PROFILE") {
							//$(pThis).closest('.lxProfHrsItem').find(".lxProfHrsItemEdit").show();
							$(pThis).closest('.lxProfHrsItem').find(".lxProfHrsItemAttTime").text(vTime);
						} else if (vOrigin == "igRsvp") {
							apex.region("igRsvp").refresh();
						}
						$("#rsvprReviewUpdate").removeClass("red");
						//$(pThis).closest(".rsvpReviewForm").remove();
					} else {
						$(pThis).closest('.rsvpReviewForm').append(d);
					}
				} else {
					$(".rsvpReviewForm").remove();
					if (vOrigin == "NOTIFY") {
						$(pThis).closest('.feed-actions').append(d);
						//$(pThis).closest('.feed-actions').find(".rsvpReviewBtn").hide();
					} else if (vOrigin == "PROFILE") {
						$(pThis).closest('.lxProfHrsItem').append(d);
						//$(pThis).closest('.lxProfHrsItem').find(".lxProfHrsItemEdit").hide();
					} else if (vOrigin == "igRsvp") {
						apex.region("igRsvp").refresh();
					}
					$("#rsvpReviewStart").datetimepicker({ dateFormat: translation.date_format, timeFormat: translation.time_format });
					$("#rsvpReviewEnd").datetimepicker({ dateFormat: translation.date_format, timeFormat: translation.time_format });
					$("#rsvpReviewVal").focus();
				}
			});
        },
		/* Created on 12.06.2018 by Davor
		 * converts HH:MM to integer of total minutes
		 * Used in rsvpReviewHrs */
        hrMinToMin: function (pHrMin) {
			var hrs, min, vList = pHrMin.split("h ");
			hrs = parseInt(lxnvl(vList[0], 0));
			min = ((vList.length == 2) ? parseInt(vList[1]) : 0);
			return hrs * 60 + min;
        },
		/* Created on 12.06.2018 by Davor
		 * converts integer of total minutes to HH:MM format string
		 * Used in rsvpReviewHrs */
        minToHrMin: function (pMins) {
			return Math.floor(pMins / 60) + "h " + ("0" + (pMins % 60)).substr(-2) + "m";
        },
		/* Created on 12.06.2018 by Davor
		 * Updates event review hours form totals
		 * called initialy (pThis is undefined) and on each form item change (pThis is the triggering item)  */
		updateTotals: function (pThis) {
			var vTotals = [], vBonusT = 0, vTotalT = 0, vVerifyT = 0, $rows, vHrs;
			// if pThis is defined then sort out that row first
			if (pThis !== undefined) {
				var vBoxCnt, $row = $(pThis).closest("tr"), vBonus;
				// number of selected halfHour boxes
				vBoxCnt = $row.find("td.selected").length;
				// Bonus minutes
				vBonus = parseInt($row.find(".bonusHrs").val());
				// if halfHour boexes or bonus minutes change then flag this row as changed
				if ($(pThis).hasClass("bonusHrs") || $(pThis).hasClass("hrs")) $row.attr("changed", "Y");
				// add updated flag and set new total value
				$row.addClass("updated").find(".total").text(lx.rsvp.review.minToHrMin((vBoxCnt * 30) + vBonus));
				// highlight apply changes button
				$row.closest(".rsvpReviewHrs").find("#rsvpReviewHrsSubmit").addClass("red");
				$rows = $row.closest("tbody");
			} else {
				$rows = $(".rsvpReviewHrs tbody");
			}
			// get maximum number of halfHour boxes
			vHrs = $rows.find("tr:first-child .hrs").length;

			// initiate vTotals collection .. each record is one column
			for (var i = 0; i < vHrs; i++) {
				vTotals.push(0);
			}
			// calculate totals
			$rows.find("tr").each(function () {
				// add 1 for each selected halfHour to collection 
				for (var i = 0; i < vHrs; i++) {
					vTotals[i] += $(this).find(".hrs.selected:nth-child(" + (i + 2) + ")").length;
				}
				// add bonus value to bonus total
				vBonusT += parseInt(lxnvl($(this).find(".bonusHrs").val(), 0));
				// add total hours value to general hour total
				vTotalT += lx.rsvp.review.hrMinToMin($(this).find(".total").text());
				// add 1 to verify total if record verified
				vVerifyT += $(this).find("input[type=checkbox]:checked").length;
			});
			//write totals
			var $totalRow = $rows.siblings("tfoot").find("tr.totals");
			// write total number of attending people on each halfHour
			for (var i = 0; i < vHrs; i++) {
				$totalRow.find("td:nth-child(" + (i + 2) + ")").text(vTotals[i]);
			}
			$totalRow.find(".bonusHrs").text(lx.rsvp.review.minToHrMin(vBonusT));
			$totalRow.find(".total").text(lx.rsvp.review.minToHrMin(vTotalT));
			$totalRow.find(".verify").text(vVerifyT);
		}
		,
		/* Created on 12.06.2018 by Davor
		 * Sets event review hours form halfHour box to selected or not selected and updates all totals on the form
		 * called from click event on editable halfHour boxes */
		hrsToggle: function (pThis) {
			$(pThis).toggleClass("selected");
			lx.rsvp.review.updateTotals(pThis);
		},
		genSelectbox: function (options) {
			var vRet = "", vClass = "", vId = "";
			if (options.id) vId = ' id="' + options.id + '"';
			if (options.class) vClass = ' class="' + options.class + '"';
			if (options.edit) {
				for (var i = 0; i < options.lov.length; i++) {
					vRet += '<option value="' + options.lov[i].r + ((options.selected == options.lov[i].r) ? '" selected="selected' : '') + '">' + options.lov[i].d + '</option>';
				}
				vRet = '<select' + vId + vClass + '>' + vRet + '</select>';
			} else {
				for (var i = 0; i < options.lov.length; i++) {
					if (options.lov[i].r == options.selected)
						vRet = '<input' + vId + vClass + ' type="hidden" value="' + options.lov[i].r + '" />' + options.lov[i].d;
				}
			}

			return vRet;
		},
		/* Created on 12.06.2018 by Davor
		 * Submits event review hours form, only updated rows are submited
		 * called from form Apply Changes button */
		hrsSubmit: function (pEventId, pThis) {
			var vData = [], vHrs, $form = /*$(pThis).closest(".rsvpReviewHrs")*/ $(".rsvpReviewHrs"), $sts, vStatus;
			// collect data from updated rows
			$form.find("tr.updated").each(function () {
				vHrs = "";
				// form halfHours string (eg. YYYYNNNNY)
				$(this).find("td.hrs").each(function () {
					if ($(this).hasClass("selected")) vHrs += 'Y';
					else vHrs += 'N';
				});
				// determine status .. if checked then pass status A, if unchecked and old status is A then pass null, all other situations pass old status (no show, excused)
				$sts = $(this).find("input[type=checkbox]");
				vStatus = $sts.attr("oldvalue");
				if ($sts.is(':checked')) vStatus = 'A'
				else if (vStatus == 'A') vStatus = '';
				// push row data to collection
				vData.push($(this).attr("rid")
					+ ":" + vHrs
					+ ":" + $(this).find(".bonusHrs").val()
					+ ":" + vStatus
					+ ":" + $(this).attr("changed"));
			});
			lx.load.add();
			$.ajax({
				url: "wwv_flow.show",
				dataType: "text",
				traditional: true,
				cache: false,
				type: "POST",
				data: {
					p_flow_id: $v("pFlowId"),
					p_flow_step_id: $v("pFlowStepId"),
					p_instance: $v("pInstance"),
					p_request: "APPLICATION_PROCESS=rsvpReviewHrsSubmit",
					x01: pEventId,
					x02: vData.join(";")
				},
				success: function (d) {
					lx.load.remove();
					// alert user if something went wrong
					if (d.trim() == "OK") {
						$(".rsvpReviewHrs").find("#rsvpReviewHrsSubmit").removeClass("red");//$(".rsvpReviewHrs").dialog("close");
						//apex.region("igRsvp").refresh();
						apex.event.trigger( "#igRsvp", "apexrefresh" );
					} else { alert(d); $(".rsvpReviewHrs").dialog("close"); }
				}
			});
		},
		/* Created on 12.06.2018 by Davor
		 * Fetches event review hours data and generates popup
		 * called in article.feed_rsvp only if event.review_form flag is set to N */
        hrsForm: function (pEventId, pRsvpId, pThis) {
			var vOrigin = "NOTIFY";
			lx.load.add();
			$.ajax({
				url: "wwv_flow.show",
				dataType: "json",
				traditional: true,
				cache: false,
				type: "POST",
				data: {
					p_flow_id: $v("pFlowId"),
					p_flow_step_id: $v("pFlowStepId"),
					p_instance: $v("pInstance"),
					p_request: "APPLICATION_PROCESS=rsvpReviewHrs",
					x01: pEventId,
					x02: pRsvpId
				},
				success: function (d) {
					lx.load.remove();
					var vHtml = "", vBoxes, vHour, vMin, vRowEdit, vSaveBtn = false, vVerify, vVerifyCol = (d.edit == "A" || d.review == 'U');
					var vHeader1 = "";
					var lButtons = [];
					// Calculate number of half hour boxes
					vBoxes = parseInt(d.hrs) * 2;
					if (d.min > 45) vBoxes += 2;
					else if (d.min > 15) vBoxes++;
					// determin starting hour
					vHour = parseInt(d.startHr);
					if (d.startMin > 15) vMin = "30";
					else vMin = "00";
					// print hour headers
					for (var i = 0; i < vBoxes + 1; i++) {
						vHtml += '<th><div><span>' + vHour + '</span><p>' + vMin + '</p></div></th>';
						if (vMin == "00") vMin = "30";
						else if (vHour == 23) { vHour = 0; vMin = "00" }
						else { vHour++; vMin = "00"; }
					}
					// form header
					vHtml = '<tr><th>' + lx.tran.get('ATTENDEES') + '</th><th colspan="' + (vBoxes) + '">' + lx.tran.get('HOURS') + '</th><th class="normal" style="min-width: 120px;">' + lx.tran.get('BONUS_H') + '</th><th class="normal" style="min-width: 72px;">' + lx.tran.get('TOTAL_H') + '</th><th class="normal" style="min-width: 72px;">' + lx.tran.get('PRESENT') + '</th></tr>'
						+ '<tr class="hourHdrs"><th></th>' + vHtml + '</tr></thead><tbody>';
					// print rows
					for (var i = 0; i < d.rows.length; i++) {
						// determine if row is editable
						vRowEdit = d.edit == 'A' || (d.edit == 'R' && d.rows[i].id == d.current_id && (d.review == 'U' || (d.review == 'V' && d.rows[i].sts != 'A')));
						// determine if save button will be printed
						if (!vSaveBtn && vRowEdit) vSaveBtn = true;
						// determine if verify checkbox will be editable 
						vVerify = (d.edit == 'A') || (d.edit == 'R' && d.rows[i].id == d.current_id && d.review == 'U');
						// print row (rid - row ID, changed - if hours or bonus has been changed from the original one)
						vHtml += '<tr rid="' + d.rows[i].id + '" changed="' + d.rows[i].changed + '"';
						// add editable class if row editable
						if (vRowEdit) vHtml += ' class="editable"';
						// print attendee name and work position
						vHtml += '><td>' + d.rows[i].attendee + '<br /><span>' + d.rows[i].wp + '</span></td>';
						// print hour boxes
						for (var j = 0; j < vBoxes; j++) {
							// half hour box = Y > .selected
							if (d.rows[i].hours.substr(j, 1) == 'Y')
								vHtml += '<td class="hrs selected"></td>';
							else vHtml += '<td class="hrs"></td>';
						}
						// show bonus, total and verify items only for users row, or for all rows if event manager
						if (d.edit == 'A' || d.rows[i].id == d.current_id) {
							vHtml += '<td>' + lx.rsvp.review.genSelectbox({ class: "bonusHrs", lov: d.bonusLov, selected: d.rows[i].bonus, edit: vVerify }) + '</td>';
							vHtml += '<td class="total">' + lx.rsvp.review.minToHrMin((lx.util.occurrences(d.rows[i].hours, 'Y') * 30 + parseInt(d.rows[i].bonus))) + '</td>';
							// old value is needed because we might need to preserve it (no show, excused)
							vHtml += '<td><input type="checkbox" value="A" oldvalue="' + d.rows[i].sts
								+ ((d.rows[i].sts == 'A') ? '" checked="checked' : '')
								+ ((vVerify) ? '' : '" disabled="disabled') + '" /></td>';
						} else {
							vHtml += '<td></td><td>' + /*lx.rsvp.review.minToHrMin( lx.util.occurrences(d.rows[i].hours,'Y') * 30 ) +*/'</td><td></td>';
						}
						vHtml += '</tr>';
					}
					// add table container and buttons
					
					vHtml = '<div class="rsvpReviewHrs"><table><thead>'
						+ '<tr><th colspan="' + (vBoxes + 4) + '">' /*+ lx.tran.get('REVIEW_ATTENDANCE')
						+ ((d.edit != 'N' && vSaveBtn) ? '<div onclick="lx.rsvp.review.hrsSubmit(' + pEventId + ',this);" class="feed-btn" id="rsvpReviewHrsSubmit">' + lx.tran.get('APPLY_CHANGES') + '</div>' : '')
						+ '<div onclick="$(\'.rsvpReviewHrs\').dialog(\'close\');" class="feed-btn">' + lx.tran.get('CLOSE') + '</div>'*/
						+ '</th></tr>'
						+ vHtml
						+ '</tbody><tfoot><tr class="totals"><td>' + lx.tran.get('TOTAL') + '</td>';
						
					// total header boxes
					for (var i = 0; i < vBoxes; i++) {
						vHtml += '<td>0</td>';
					}
					vHtml += '<td class="bonusHrs">0:00</td><td class="total">0:00</td><td class="verify">0</td></tr></tfoot></table></div>';
					// remove provious review form
					$(".rsvpReviewHrs").remove();
					// open review form as a modal dialog
					/*$(vHtml).dialog({title: lx.tran.get('REVIEW_ATTENDANCE'),  modal: true, width: "960px",
						buttons: [{
							text: 'APPLY_CHANGES',
							click: function () {
								lx.rsvp.review.hrsSubmit(' + pEventId + ',this);
								//$(this).dialog("close");
							}
					}]
					});*/
					
					lButtons.push({label: lx.tran.get('APPLY_CHANGES'), id: "AppplyId", js: 'lx.rsvp.review.hrsSubmit(' + pEventId + ',this);', class:"t-Button--primary", fa:"fas fawe-save"});
					//lButtons.push( {label: lx.tran.get('CLOSE'), id: "CloseId", js: 'lxpDialog.close(this);', class:"t-Button--primary", fa:"fa fa-times"});
					
					 lx.dialog.open({id:"rsvpHrs", maxWidth: "960px", title: lx.tran.get('REVIEW_ATTENDANCE'), html: vHtml, buttons:lButtons});
					
					// update form totals
					lx.rsvp.review.updateTotals();
					// bind events to editable form items
					$(".rsvpReviewHrs tr.editable .hrs").click(function () { lx.rsvp.review.hrsToggle(this); });
					$(".rsvpReviewHrs tr.editable select.bonusHrs").change(function () { lx.rsvp.review.updateTotals(this); });
					$(".rsvpReviewHrs tr.editable input[type=checkbox]").change(function () { lx.rsvp.review.updateTotals(this); });
				}
			});
		}
    }
}
